import Cookies from 'cookies';

interface TargetCookies {
  country?: string | null,
  region?: string | null,
  locale?: string | null,
  cookies?: Cookies,
}

export default async function setTargetCookies({
  country,
  region,
  locale,
  cookies,
}: TargetCookies) {
  if (cookies) {
    try {
        cookies.set('locale', locale, { httpOnly: false });
        cookies.set('country', country || null, { httpOnly: false });
        cookies.set('region', region || null, { httpOnly: false });
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error,
      };
    }
  } else {
    return {
      success: false,
      error: 'Cookies are undefined'
    };
  }
}